import React from 'react'
import {submitFeeClassTableData} from "../api/api";
import { Button} from 'antd'
import {useHistory} from "react-router-dom";
import {DefaultProps, RefTable, Validator} from "./RefTable";

export const ViewEMs = (props)=>{
    const history = useHistory()
    return <Button key={props.value} onClick={() => {
        history.push({
            pathname: '/view/em-info',
            state: {filter: {"fee_class_id_effective": props.value}}
        })
    }}>View</Button>
}

export const FeeClasses = (props) => <RefTable {...props}/>;

FeeClasses.defaultProps = {
    ...DefaultProps,
    title: "Fee Classes",
    tableSchema: "fee_class",
    tableName: "fee_classes",
    edit: true,
    theadHeight: 62,
    enrichColumns: async (columns) => {
        return [
            {
                name: "id",
                title: "Associated EMs",
                width: 120,
                formatter: (row, index, name, type, formatted, value) => <ViewEMs value={value}/>
            }, ...columns]
    },
    updateData: async (tableName, data)=>submitFeeClassTableData(data),
    validator: [
        "import_scheme_fixed_fee",
        "non_union_fixed_fee",
        "union_fixed_fee",
        "b2c_domestic_fixed_fee",
        "import_percentage_fee",
        "non_union_percentage_fee",
        "union_percentage_fee",
        "b2c_domestic_percentage_fee"
    ].reduce((acc, cur) => {
        return {
            ...acc, [cur]: new Validator(cur, async (value) => {
                if (value < 0)
                    return Promise.reject("Field cannot be negative")
            })
        }
    }, {
        min_order_count: new Validator("min_order_count", async (value, column, {min_trade_value, max_trade_value})=> {
            if (value < 0)
                return Promise.reject("Field cannot be negative")
            if (value > 0 && (min_trade_value > 0 || max_trade_value > 0))
                return Promise.reject("Cannot set both order Counts and Trade values")
        }, ["min_trade_value", "max_trade_value"]),
        max_order_count: new Validator("max_order_count", async (value, column, {min_trade_value, max_trade_value})=> {
            if (value < 0)
                return Promise.reject("Field cannot be negative")
            if (value > 0 && (min_trade_value > 0 || max_trade_value > 0))
                return Promise.reject("Cannot set both order Counts and Trade values")
        }, ["min_trade_value", "max_trade_value"]),
        min_trade_value: new Validator("min_trade_value", async (value, column, {min_order_count, max_order_count})=> {
            if (value < 0)
                return Promise.reject("Field cannot be negative")
            if (value > 0 && (min_order_count > 0 || max_order_count > 0))
                return Promise.reject("Cannot set both order Counts and Trade values")
        }, ["min_order_count", "max_order_count"]),
        max_trade_value: new Validator("max_trade_value", async (value, column, {min_order_count, max_order_count})=> {
            if (value < 0)
                return Promise.reject("Field cannot be negative")
            if (value > 0 && (min_order_count > 0 || max_order_count > 0))
                return Promise.reject("Cannot set both order Counts and Trade values")
        }, ["min_order_count", "max_order_count"]),
        fc_rep_fixed_fee: new Validator    ("fc_rep_fixed_fee", async (value, column, {import_scheme_fixed_fee})=> {
            if (value < 0)
                return Promise.reject("Field cannot be negative")
            if(value > import_scheme_fixed_fee)
                return Promise.reject("FC Rep Fixed Fee cannot be greater than Import Fixed Fee")
        }, ["import_scheme_fixed_fee"]),
        fc_rep_percentage_fee: new Validator("fc_rep_percentage_fee", async (value, column, {import_percentage_fee})=> {
            if (value < 0)
                return Promise.reject("Field cannot be negative")
            if(value > import_percentage_fee)
                return Promise.reject("FC Rep Percentage Fee cannot be greater than Import Percentage Fee")
        }, ["import_percentage_fee"])
    }),
}
